<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-icon :disabled="permission" :color="actionColor" @click="onClick(data)" v-bind="attrs" v-on="on">
        {{ icon }}
      </v-icon>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
const props = {
  icon: {
    default: "mdi-person",
    type: String,
  },
  text: {
    default: "No disponible",
    type: String,
  },
  permission: {
    default: false,
    type: Boolean,
  },
  actionColor: {
    default: "green",
    type: String,
  },
  data: {
    type: undefined,
  },
  onClick: Function,
};

export default {
  data: () => ({
    valueOk: false,
  }),
  methods: {},
  props: props,
};
</script>

<style scoped></style>
